import React from 'react';
import { ProductViewModel } from '@/types/cml-api';
import { AppNextLink } from '@/features/app-next-link';
import LazyImage from '@/features/image/lazy-image';
type Props = {
  product: ProductViewModel;
  onClick: () => void;
};
const TextStoryProductCard = ({
  product,
  onClick
}: Props) => {
  const productLink = `/products/${product?.slug}`;
  return <AppNextLink onClick={onClick} href={productLink} className='flex max-w-xs flex-1 items-center rounded bg-white p-2' data-sentry-element="AppNextLink" data-sentry-component="TextStoryProductCard" data-sentry-source-file="text-story-product-card.tsx">
            <picture className='flex h-full' data-sentry-element="picture" data-sentry-source-file="text-story-product-card.tsx">
                <source media='(min-height: 50px)' srcSet={product?.mainImageUrl} />
                <LazyImage src={product?.mainImageUrl || ''} alt={product?.nameFa || ''} className='h-[50px] w-[50px] w-full min-w-[50px]' loaderClassName='h-[50px]' isLazy={true} data-sentry-element="LazyImage" data-sentry-source-file="text-story-product-card.tsx" />
            </picture>
            <p className='mr-2 line-clamp-3 text-caption-10'>
                {product?.nameFa} {product?.brand?.nameFa}
            </p>
        </AppNextLink>;
};
export default TextStoryProductCard;